var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":"primary","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" "+_vm._s(_vm.$t('save'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }